import { useMemo } from 'react';
import { useDashboardContext } from '../DashboardContext';
import { type SeriesFields } from './typings';

const useLegendSelectedConfig = ({ currentMonth, lastMonth }: SeriesFields) => {
    const {
        state: { displayCurrentMonth, displayLastMonth },
    } = useDashboardContext();

    return useMemo(
        () => ({
            [currentMonth]: displayCurrentMonth,
            [lastMonth]: displayLastMonth,
        }),
        [currentMonth, lastMonth, displayCurrentMonth, displayLastMonth]
    );
};

export default useLegendSelectedConfig;
